import { render, staticRenderFns } from "./VueDialog.vue?vue&type=template&id=132c203b&"
import script from "./VueDialog.vue?vue&type=script&lang=js&"
export * from "./VueDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports